import { Link } from '@tanstack/react-router';
import { ChevronRight, MessageCircle } from 'lucide-react';

/**
 * Raccourci vers « Mes discussions » sur les pages « Mes contacts » — mirroir
 * exact de `files-shortcut.tsx`. Les barres de navigation mobiles restent
 * pleines/symétriques (inchangées) : c'est ici que le mobile y accède.
 */
export function DiscussionsShortcut({ to }: { to: '/tutor/discussions' | '/student/discussions' }) {
  return (
    <Link
      to={to}
      className="border-ink-100 flex min-h-[2.75rem] items-center gap-3 rounded-2xl border bg-white p-3 transition-colors active:scale-[0.98]"
    >
      <span className="bg-primary-50 text-primary-600 flex size-10 shrink-0 items-center justify-center rounded-xl">
        <MessageCircle className="size-5" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="text-ink-900 block text-sm font-semibold">Mes discussions</span>
        <span className="text-ink-500 block truncate text-xs">
          Fils de discussion ouverts avec tes contacts
        </span>
      </span>
      <ChevronRight className="text-ink-400 size-4 shrink-0" aria-hidden />
    </Link>
  );
}
